<template>
  <el-dialog
    v-el-drag-dialog
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    :title="$l('deviceGateway.editDevice','编辑网关设备')"
    width="1500px"
    top="3vh"
    @close="$reset('form')">
    <el-form
      ref="form"
      :label-width="$l('elevatorNetApply.labelWidth','120px')"
      :model="model">
      <div v-if="model.id > 0" class="vm-separate">
        <el-form-item label="注册(设备)代码">
          <el-input v-model.trim="model.regNo" disabled=""></el-input>
        </el-form-item>
        <div></div>
        <div></div>
      </div>
      <div class="vm-separate">
        <el-form-item label="终端编号" prop="inshnId" :rules="$rule.notNull">
          <el-input v-model.trim="model.inshnId" :placeholder="$t('common.pleaseEnter')"></el-input>
        </el-form-item>
        <el-form-item label="红外类型" prop="inshnIo" :rules="$rule.notNull">
          <el-select
            v-model="model.inshnIo"
            :placeholder="$t('common.pleaseSelect')"
            style="width: 100%">
            <el-option
              v-for="item in inshnIoList"
              :key="item.value"
              :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="电梯速度" prop="inshnSpeed" :rules="$rule.notNull">
          <el-input v-model.trim="model.inshnSpeed" type="number" :placeholder="$t('common.pleaseEnter')"></el-input>
        </el-form-item>
      </div>
      <div class="vm-separate">
        <el-form-item label="轿门类型" prop="inshnDoorType" :rules="$rule.notNull">
          <el-select
            v-model="model.inshnDoorType"
            :placeholder="$t('common.pleaseSelect')"
            style="width: 100%">
            <el-option
              v-for="item in inshnDoorTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="异常判断次数" prop="inshnDoorCnt" :rules="$rule.notNull">
          <el-input type="number" v-model.trim="model.inshnDoorCnt" :placeholder="$t('common.pleaseEnter')"></el-input>
        </el-form-item>
        <el-form-item label="开门时间" prop="inshnDoorTime" :rules="$rule.notNull">
          <el-input type="number" v-model.trim="model.inshnDoorTime" :placeholder="$t('common.pleaseEnter')"></el-input>
        </el-form-item>
      </div>
      <div class="vm-separate">
        <el-form-item label="平层间距" prop="inshnNextTime" :rules="$rule.notNull">
          <el-input type="number" v-model.trim="model.inshnNextTime" :placeholder="$t('common.pleaseEnter')"></el-input>
        </el-form-item>
        <el-form-item label="SIM卡ICCID" prop="iccid">
          <el-input v-model.trim="model.iccid" :placeholder="$t('common.pleaseEnter')"></el-input>
        </el-form-item>
        <el-form-item label="手机号码" prop="inshnRegtel" :rules="$rule.notNull">
          <el-input v-model.trim="model.inshnRegtel" :placeholder="$t('common.pleaseEnter')"></el-input>
        </el-form-item>
      </div>
      <div class="vm-separate">
        <el-form-item label="传感器" prop="inshnFiltering" :rules="$rule.notNull">
          <el-select
            v-model="model.inshnFiltering"
            :placeholder="$t('common.pleaseSelect')"
            style="width: 100%">
            <el-option
              v-for="item in inshnFilteringList"
              :key="item.value"
              :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="网络制式" prop="inshnNetctype" :rules="$rule.notNull">
          <el-select
            v-model="model.inshnNetctype"
            :placeholder="$t('common.pleaseSelect')"
            style="width: 100%">
            <el-option
              v-for="item in inshnNetctypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <div></div>
      </div>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">{{$l("elevatorNetApply.cancel", "取消")}}</el-button>
      <el-button
        :loading="submitLoading"
        type="primary"
        @click="handleSubmit">{{$l("elevatorNetApply.save", "保存")}}</el-button>
    </span>
  </el-dialog>
</template>

<script>

  export default {
    data() {
      return {
        dialogVisible: false,
        submitLoading: false,
        model: {
          id: 0,
          inshnId: "",
          inshnIo: "",
          inshnSpeed: "",
          inshnDoorType: "",
          inshnDoorCnt: "",
          inshnDoorTime: "",
          inshnNextTime: "",
          inshnRegtel: "",
          iccid: "",
          inshnFiltering: "",
          inshnNetctype: "",
          regNo: "",
        },
        inshnIoList: [{value: 0, label: "常闭"}, {value: 1, label: "常开"}],
        inshnDoorTypeList: [{value: 0, label: "单门"}, {value: 1, label: "双门"}, {value: 2, label: "单门+烟感"}, {
          value: 3,
          label: "单门+开门到位",
        }],
        inshnFilteringList: [{value: 10, label: "其他"}, {value: 3, label: "U型"}],
        inshnNetctypeList: [{value: 0, label: "有线"}, {value: 1, label: "2G"}, {value: 2, label: "3G"}, {
          value: 3,
          label: "4G",
        }],
      };
    },
    methods: {
      open(id, regNo) {
        this.model.id = id;
        this.dialogVisible = true;
        if (this.model.id) {
          this.model.regNo = regNo;
          this.getData();
        }
      },
      getData() {
        this.$http
          .get("deviceGatewayInsh/" + this.model.id)
          .then(({data}) => {
            this.$assign(this.model, data);
          });
      },
      handleSubmit() {
        if (this.model.inshnRegtel) {
          let rule = /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|19[0-9]|14[57])[0-9]{8}$/;
          if (!rule.test(this.model.inshnRegtel)) {
            return this.$message.error("请输入正确的手机号");
          }
        }
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http.save("deviceGatewayInsh", this.model)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success(this.$t("common.tip.saveSuccess"));
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
